import styled from 'styled-components';
import { darken, shade } from 'polished';

export const Content = styled.div`
  display: block;
  width: 100%;
`;

export const Grid = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 12px;
  background: #fff;
  display: block;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
`;

export const Bloco = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding: 25px;

  h2 {
    color: #0059b2;
    font-size: 26px;
  }

  a {
    background: #0faf69;
    padding: 10px 36px;
    color: #fff;
    align-items: center;
    border-radius: 6px;
    display: flex;
  }

  a:hover {
    background: ${darken(0.03, '#0FAF69')};
  }
`;

export const Button = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  align-items: flex-end;
  padding-top: 6px;
  padding-bottom: 12px;
  padding-left: 20px;

  button {
    background: #0faf69;
    padding: 10px 36px;
    color: #fff;
    border-radius: 6px;
    display: flex;
    border: 0;

    &:hover {
      background: ${darken(0.03, '#0FAF69')};
    }
  }
`;

export const BForm = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 8px;

  .bloco_btn {
    display: flex;
    flex-direction: row;
    flex: 1;
    width: 100%;
    justify-content: space-between;

    .btn {
      display: flex;
      flex-direction: row;
    }
  }

  hr {
    height: 28px;
    margin-left: 12px;
    margin-right: 12px;
    margin-top: 14px;
  }

  input {
    width: 100%;
    height: 42px;
    border-radius: 12px;
    border: 1px solid #ccc;
    padding-left: 5px;
  }

  a {
    width: 100%;
    height: 42px;
    border-radius: 12px;
    border: 1px solid #ccc;
    padding-left: 5px;
  }

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    border: 1px solid #ccc;
  }

  .cno {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 5px;

    span {
      font-size: 12px;
    }

    .cno-cei {
      margin-left: 6px;
    }
  }

  select {
    width: 100%;
    height: 42px;
    border-radius: 12px;
    border: 1px solid #ccc;
    padding-left: 5px;
  }

  div {
    display: flex;
    flex: 1;
    flex-direction: column;
    position: relative;

    ul {
      position: absolute;
      display: ${Props => (Props.ativo ? 'block' : 'block')};
      top: 70px;
      list-style: none;
      width: 100%;
      overflow-y: scroll;
      max-height: 110px;
      background: #fff;

      li {
        background: #ccc;
        width: 99%;
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 4px;
        padding-right: 4px;
        font-size: 11px;
        cursor: pointer;

        &:hover {
          background: #eee;
        }
      }

      li + li {
        margin-top: 3px;
      }
    }

    label {
      padding-bottom: 5px;
      color: #333;
      font-size: 12px;
      padding-left: 4px;
    }
  }

  div + div {
    margin-left: 6px;
  }

  .btn-editar {
    border: 0;
    background: #ccc;
    border-radius: 5px;
    width: 140px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #eee;
    }
  }

  .btn-save {
    border: 0;
    background: #0faf69;
    color: #fff;
    border-radius: 5px;
    width: 140px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${darken(0.03, '#0FAF69')};
    }
  }

  .btn-white {
    border: 0;
    background: #eee;
    color: #000;
    border-radius: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${darken(0.03, '#eee')};
    }
  }

  .btn-cno {
    border: 0;
    background: #0faf69;
    color: #fff;
    border-radius: 5px;
    width: 100%;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 2px;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${darken(0.03, '#0FAF69')};
    }
  }

  .btn-warning {
    border: 0;
    background: #00468c;
    color: #fff;
    border-radius: 5px;
    width: 140px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 18px;
    }

    &:hover {
      background: ${darken(0.03, '#FF8000')};
    }
  }

  span + span {
    margin-left: 8px;
  }

  .btnObrigacoes {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    button {
      display: flex;
      flex-direction: row;

      & + button {
        margin-left: 4px;
      }
    }
  }
`;

export const Modal = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 9;
  display: ${Props => (Props.modal ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

export const ContentModal = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: column;

  h4 {
    font-size: 28px;
    width: 100%;
    text-align: center;
  }

  div {
    display: flex;

    button + button {
      margin-left: 4px;
    }
  }

  .btn-save {
    border: 0;
    background: #0faf69;
    color: #fff;
    border-radius: 5px;
    width: 140px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${darken(0.03, '#0FAF69')};
    }
  }

  .btn-delete {
    border: 0;
    background: #ff4d4d;
    color: #fff;
    border-radius: 5px;
    width: 140px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${darken(0.03, '#FF4D4D')};
    }
  }
`;

export const FormList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 6px;
  padding-right: 6px;

  h4 {
    margin-top: 12px;
  }

  .orange {
    height: 35px;
    padding-left: 8px;
    padding-right: 8px;
    border: 0;
    background: #003f7f;
    color: #fff;
    margin-top: 5px;

    &:hover {
      opacity: 0.6;
    }
  }

  button {
    height: 35px;
    padding-left: 8px;
    padding-right: 8px;
    border: 0;
    background: #00b259;
    color: #fff;

    &:hover {
      opacity: 0.6;
    }
  }
`;

export const InputDate = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    width: auto;
  }

  button {
    background: #ff4d4d;
    color: #fff;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    transition: background-color 0.2s;

    &:hover {
      background: ${shade(0.3, '#FF4D4D')};
    }
  }
`;
